import React, { useState, useEffect } from "react";
import ParentPanel from "../panel/ParentPanel";
import api from "../../../api/api";
import "../styles/assignment.css";



const AssignmentPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [uploads, setUploads] = useState({});
  const [activeSubject, setActiveSubject] = useState("");
  const [collapsedAssignments, setCollapsedAssignments] = useState({});
  const [assignmentsData, setAssignmentsData] = useState([]);

  const token = localStorage.getItem("token");

  // Fetch assignments from backend
  const fetchAssignments = async () => {
  try {
    const res = await api.get("/api/assignments/student");

    const grouped = {};

    res.data.forEach(a => {
      if (!grouped[a.subject]) grouped[a.subject] = {};
      if (!grouped[a.subject][a.teacher_name])
        grouped[a.subject][a.teacher_name] = [];

      grouped[a.subject][a.teacher_name].push({
        id: a.id,
        title: a.topic,
        dueDate: a.due_date.split("T")[0],
        file: a.fileUrl,
        type: a.type,
        comment: a.comment,
      });
    });

    const structured = [];

    Object.keys(grouped).forEach(subject => {
      Object.keys(grouped[subject]).forEach(teacher => {
        structured.push({
          teacher,
          subject,
          assignments: grouped[subject][teacher],
        });
      });
    });

    setAssignmentsData(structured);

    if (structured.length && !activeSubject) {
      setActiveSubject(structured[0].subject);
    }

  } catch (err) {
    console.error("❌ Failed to fetch assignments:", err);
  }
};

  useEffect(() => {
    fetchAssignments();
  }, []);

  const handleUploadChange = (assignmentId, field, value) => {
    setUploads(prev => ({
      ...prev,
      [assignmentId]: { ...prev[assignmentId], [field]: value },
    }));
  };

  const handleSubmit = assignmentId => {
    alert(`Assignment ${assignmentId} submitted!`);
    // TODO: send uploads[assignmentId] to backend
  };

  const toggleAssignment = id => {
    setCollapsedAssignments(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const subjects = [...new Set(assignmentsData.map(a => a.subject))];

  const isOverdue = dueDate => {
    const today = new Date();
    return new Date(dueDate) < today;
  };

  const parseYouTubeTime = comment => {
    const match = comment?.match(/(\d+):(\d+)/g);
    if (match && match.length >= 2) {
      const [start, end] = match;
      const startSec = parseInt(start.split(":")[0]) * 60 + parseInt(start.split(":")[1]);
      const endSec = parseInt(end.split(":")[0]) * 60 + parseInt(end.split(":")[1]);
      return { start: startSec, end: endSec };
    }
    return {};
  };

  return (
    <>
      <ParentPanel onToggle={setIsSidebarCollapsed} />
      <div className={`parent-work-main ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <h2>Assignments</h2>

        {/* Subject Tabs */}
        <div className="subject-tabs">
          {subjects.map(subject => (
            <button
              key={subject}
              className={`subject-tab ${activeSubject === subject ? "active" : ""}`}
              onClick={() => setActiveSubject(subject)}
            >
              {subject}
            </button>
          ))}
        </div>

        {/* Assignment Cards */}
        {assignmentsData
          .filter(sec => sec.subject === activeSubject)
          .map(section => (
            <div key={section.teacher} className="teacher-section">
              <div className="teacher-header" onClick={() => toggleAssignment(section.teacher)}>
                <h3>{section.teacher}</h3>
                <span>{collapsedAssignments[section.teacher] ? "▼" : "▲"}</span>
              </div>

              {!collapsedAssignments[section.teacher] && (
                <div className="work-cards">
                  {section.assignments.map(asgn => {
                    const overdue = isOverdue(asgn.dueDate);
                    const ytTime = asgn.type === "youtube" ? parseYouTubeTime(asgn.comment) : {};

                    return (
                      <div
                        key={asgn.id}
                        className={`assignment-card ${overdue ? "overdue" : ""}`}
                      >
                        <div className="assignment-header">
                          <h4>{asgn.title}</h4>
                          <span>Due: {asgn.dueDate}</span>
                          <span className={`assignment-type-badge ${asgn.type}`}>
                            {asgn.type.toUpperCase()}
                          </span>
                          <span className={`submission-status ${uploads[asgn.id] ? "submitted" : "pending"}`}>
                            {uploads[asgn.id] ? "Submitted" : "Pending"}
                          </span>
                        </div>

                        {asgn.comment && <p className="teacher-comment">💬 {asgn.comment}</p>}

                        {/* File Preview */}
                        {asgn.type === "image" && (
                          <img src={asgn.file} className="assignment-image" alt={asgn.title} />
                        )}
                        {asgn.type === "video" && (
                          <video controls className="assignment-video">
                            <source src={asgn.file} type="video/mp4" />
                          </video>
                        )}
                        {asgn.type === "youtube" && (
                          <iframe
                            className="assignment-video"
                            src={`${asgn.file}?start=${ytTime.start || 0}&end=${ytTime.end || ""}`}
                            title={asgn.title}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        )}
                        {asgn.type === "pdf" && (
                          <iframe src={asgn.file} className="assignment-pdf" title={asgn.title}></iframe>
                        )}

                        {/* Download */}
                        {asgn.file && (
                          <a href={asgn.file} download className="download-btn">
                            Download {asgn.type.toUpperCase()}
                          </a>
                        )}

                        {/* Student Submission */}
                        <div className="assignment-upload">
                          <textarea
                            placeholder="Write your submission..."
                            value={uploads[asgn.id]?.text || ""}
                            onChange={e => handleUploadChange(asgn.id, "text", e.target.value)}
                          />
                          <input
                            type="file"
                            accept="image/*,video/*,application/pdf,.doc,.docx"
                            onChange={e => handleUploadChange(asgn.id, "file", e.target.files[0])}
                          />
                          {uploads[asgn.id]?.file && <p>Selected File: {uploads[asgn.id].file.name}</p>}
                          <button onClick={() => handleSubmit(asgn.id)}>Submit Assignment</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
      </div>
    </>
  );
};

export default AssignmentPage;
